export const HERO_CAROUSEL_HEIGHT = '70vh';
